import React from 'react'

const PremiumSkeleton: React.FC = () => (
  <div className="mx-auto p-4 justify-items-center gap-4 grid grid-flow-row text-neutral-600 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2">
    <div className="masonry-block bg-gray-300 w-full h-96 rounded-xl animate-pulse" />
    <div className="masonry-block bg-gray-300 w-full h-96 rounded-xl animate-pulse" />
    <div className="masonry-block bg-gray-300 w-full h-96 rounded-xl animate-pulse" />
    <div className="masonry-block bg-gray-300 w-full h-96 rounded-xl animate-pulse" />
  </div>
)

export default PremiumSkeleton
